/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable no-console */
/* eslint-disable max-len */
/* eslint-disable @typescript-eslint/no-floating-promises */

import {
  CaretDownOutlined,
  CaretUpOutlined,
  TrophyOutlined
} from '@ant-design/icons';
import {Menu as MenuAnt, MenuProps} from 'antd';
import React, {useMemo} from 'react';
import {Link, useLocation} from 'react-router-dom';

import {ReactComponent as AIOCR} from '../../assets/AIOCR.svg';
import {ReactComponent as OM} from '../../assets/icons/Building_01.svg';
import {ReactComponent as Comms} from '../../assets/icons/Comms.svg';
import {ReactComponent as CONFIG_SVG} from '../../assets/icons/configurator.svg';
import {ReactComponent as Dashboard} from '../../assets/icons/Dashboard.svg';
import {ReactComponent as Esg} from '../../assets/icons/Esg.svg';
import {ReactComponent as HomeIcon} from '../../assets/icons/HomeIcon.svg';
import {ReactComponent as NZM} from '../../assets/icons/NZM.svg';
import {ReactComponent as PCFIcon} from '../../assets/icons/PCFIcon.svg';
import {processTypeFilter} from '../../constants/Common';
import {PermissionEnum} from '../../constants/permissionsEnum';
import {Routes, allRoutes, subRoutes} from '../../constants/Routes';
import TranslatedText from '../../libraries/I18N/TranslatedText';
import {removeSlash} from '../../utils/removeSlash';

import {checkIfHasPermissions, sideNavMapping} from './Utils/commonFunctions';

const Menu: React.FC<{
  setOpenKeys: React.Dispatch<React.SetStateAction<string[]>>;
  openKeys: string[];
  product: string;
  setProduct: React.Dispatch<React.SetStateAction<string>>;
}> = ({setOpenKeys, openKeys, product, setProduct}) => {
  const location = useLocation();

  const sideNav = [
    // {
    //   key: removeSlash(Routes.HOME),
    //   icon: (
    //     <Link to={Routes.HOME}>
    //       <HomeIcon className="icon" />
    //     </Link>
    //   ),
    //   label: <TranslatedText translationKey="Home" />,
    //   route: Routes.HOME
    //   // hidden: !checkIfHasPermissions(PermissionEnum.home)
    // },

    // {
    //   key: removeSlash(Routes.CONFIGURATOR),
    //   icon: <CONFIG_SVG className="icon" />,
    //   label: <TranslatedText translationKey="CONFIGURATOR" />,
    //   route: Routes.CONFIGURATOR,
    //   // disabled: isNavDisabled(permissions?.dashboard),
    //   hidden: !checkIfHasPermissions(PermissionEnum.Configurator),
    //   children: [
    //     {
    //       key: removeSlash(subRoutes.Organisation_Facility),
    //       label: (
    //         <Link to={allRoutes.Configurator.org_facility}>
    //           <TranslatedText translationKey="Organisation & Facilities" />
    //         </Link>
    //       ),
    //       hidden: !checkIfHasPermissions(
    //         PermissionEnum.ConfiguratorOrganisationFacilities
    //       )
    //     },
    //     {
    //       key: removeSlash(subRoutes.Value_chain_management),
    //       label: (
    //         <Link to={allRoutes.Configurator.valueChainMng}>
    //           <TranslatedText translationKey="VALUE_CHAIN_MANAGEMENT" />
    //         </Link>
    //       ),
    //       hidden: !checkIfHasPermissions(
    //         PermissionEnum.ConfiguratorValueChainManagement
    //       )
    //     },
    //     {
    //       key: removeSlash(subRoutes.org_and_process_flow),
    //       label: (
    //         <Link to={allRoutes.Configurator.org_and_process_flow}>
    //           <TranslatedText translationKey="Organisation Hierarchy" />
    //         </Link>
    //       ),
    //       hidden: !checkIfHasPermissions(
    //         PermissionEnum.ConfiguratorOrganisationHierarchy
    //       )
    //     },
    //     {
    //       key: removeSlash(subRoutes.process_flow),
    //       label: (
    //         <Link to={allRoutes.Configurator.process_flow}>
    //           <TranslatedText translationKey="Process Flow" />
    //         </Link>
    //       ),
    //       hidden: !checkIfHasPermissions(PermissionEnum.ConfiguratorProcessFlow)
    //         ? true
    //         : !processTypeFilter()
    //     },
    //     // {
    //     //   key: removeSlash(subRoutes.org_and_process_flow),
    //     //   label: <TranslatedText translationKey="Organisation Hierarchy" />,
    //     //   onClick: () => {
    //     //     navigate(`${allRoutes.Configurator.org_and_process_flow}`);
    //     //   }
    //     // },
    //     {
    //       key: removeSlash(subRoutes.data_management),
    //       label: (
    //         <Link to={allRoutes.Configurator.data_management}>
    //           <TranslatedText translationKey="Data Management" />
    //         </Link>
    //       ),
    //       hidden: !checkIfHasPermissions(
    //         PermissionEnum.ConfiguratorDataManagement
    //       )
    //     },
    //     {
    //       key: removeSlash(subRoutes.userManager),
    //       label: (
    //         <Link to={allRoutes.Configurator.userManager}>
    //           <TranslatedText translationKey="User Management" />
    //         </Link>
    //       ),
    //       hidden: !checkIfHasPermissions(
    //         PermissionEnum.ConfiguratorUserManagement
    //       )
    //     }
    //     // {
    //     //   key: removeSlash(subRoutes.OCR),
    //     //   label: (
    //     //     <Link to={allRoutes.Configurator.OCRMain}>
    //     //       <TranslatedText translationKey="AI Document Manager" />
    //     //     </Link>
    //     //   )
    //     // }
    //   ]
    // },
    {
      key: removeSlash(Routes.DASHBOARD),
      icon: <Dashboard className="icon" />,
      label: <TranslatedText translationKey="DASHBOARD" />,
      route: Routes.DASHBOARD,
      // disabled: isNavDisabled(permissions?.dashboard),
      hidden: !checkIfHasPermissions(PermissionEnum.Dashboard),
      children: [
        {
          key: 'metrics',
          label: (
            <Link to={allRoutes.dashboard.metrics}>
              <TranslatedText translationKey="METRICS" />
            </Link>
          ),
          hidden: !checkIfHasPermissions(PermissionEnum.DashboardMetrics)
        },
        {
          key: 'stakeholderTracking',
          label: (
            <Link to={allRoutes.dashboard.stakeholderTracking}>
              <TranslatedText translationKey="STAKEHOLDER_TRACKING" />
            </Link>
          )
        }
      ]
    },
    {
      key: removeSlash(Routes.ORG_MANAGER),
      icon: <OM className="icon" />,
      label: <TranslatedText translationKey="ORG_MANAGER" />,
      route: Routes.ORG_MANAGER,
      // disabled: isNavDisabled(permissions?.OM),
      hidden: !checkIfHasPermissions(PermissionEnum.OrgManager),
      children: [
        {
          key: removeSlash(subRoutes.orgManager),
          label: (
            <Link to={allRoutes.OM.orgManager}>
              <TranslatedText translationKey="ORG_PROFILE" />
            </Link>
          ),
          // disabled: isNavDisabled(permissions?.OM.orgManager),
          hidden: true
        },
        {
          key: removeSlash(subRoutes.facility),
          label: (
            <Link to={allRoutes.OM.facility}>
              <TranslatedText translationKey="FACILITY_OWNERSHIP" />
            </Link>
          ),
          hidden: true
        },
        {
          key: removeSlash(subRoutes.supplierInfo),
          label: (
            <Link to={allRoutes.OM.supplier}>
              <TranslatedText translationKey="Supplier Info" />
            </Link>
          ),
          hidden: true
        },
        {
          key: removeSlash(subRoutes.infraProfile),
          label: (
            <Link to={allRoutes.OM.infraProfile}>
              <TranslatedText translationKey="ORG_INFRA_PROFILE" />
            </Link>
          ),
          // disabled: isNavDisabled(permissions?.OM.infraProfile)
          hidden: !checkIfHasPermissions(
            PermissionEnum.OrgManagerInfrastructureProfile
          )
        },
        {
          key: removeSlash(subRoutes.assetManagement),
          label: (
            <Link to={allRoutes.OM.assetManagement}>
              <TranslatedText translationKey="ASSET_MANAGER" />
            </Link>
          ),
          // disabled: isNavDisabled(permissions?.OM.assetManagement),
          hidden: !checkIfHasPermissions(PermissionEnum.OrgManagerAssetManager)
        },
        {
          key: removeSlash(subRoutes.investments),
          label: (
            <Link to={allRoutes.OM.investments}>
              <TranslatedText translationKey="INVESTMENT" />
            </Link>
          ),
          // disabled: isNavDisabled(permissions?.OM.investments),
          hidden: !checkIfHasPermissions(PermissionEnum.OrgManagerInvestment)
        },
        {
          key: removeSlash(subRoutes.products),
          label: (
            <Link to={allRoutes.OM.products}>
              <TranslatedText translationKey="PRODUCT" />
            </Link>
          ),
          hidden: !checkIfHasPermissions(PermissionEnum.OrgManagerProduct)
        }
      ]
    },
    {
      key: removeSlash(Routes.NET_ZERO),
      icon: <NZM className="icon" />,
      label: <TranslatedText translationKey="NZM" />,
      route: Routes.NET_ZERO,
      // disabled: isNavDisabled(permissions?.NZM),
      hidden: !checkIfHasPermissions(PermissionEnum.NZM),
      children: [
        {
          key: removeSlash(subRoutes.nzmGeneral),
          label: (
            <Link to={allRoutes.NZM.generalized}>
              <TranslatedText translationKey="Generalized" />
            </Link>
          ),
          hidden: !checkIfHasPermissions(PermissionEnum.NZMGeneralized)
        },
        {
          key: removeSlash(subRoutes.nzmUtilities),
          label: (
            <Link to={allRoutes.NZM.utilities}>
              <TranslatedText translationKey="Utilities" />
            </Link>
          ),
          hidden: !checkIfHasPermissions(PermissionEnum.NZMUtilities)
        },
        {
          key: removeSlash(subRoutes.nzmSC),
          label: (
            <Link to={allRoutes.NZM.supplyChain}>
              <TranslatedText translationKey="Supply Chain Transport" />
            </Link>
          ),
          hidden: !checkIfHasPermissions(PermissionEnum.NZMSupplyChain)
        },
        {
          key: removeSlash(subRoutes.nzmTravel),
          label: (
            <Link to={allRoutes.NZM.travel}>
              <TranslatedText translationKey="Travel" />
            </Link>
          ),
          hidden: !checkIfHasPermissions(PermissionEnum.NZMTravel)
        },
        // {
        //   key: removeSlash(subRoutes.nzmCG),
        //   label: <TranslatedText translationKey="Capital Goods" />,
        //   onClick: () => {
        //     navigate(`${allRoutes.NZM.capitalGoods}`);
        //   },
        //   disabled: true || isNavDisabled(permissions?.NZM.capitalGoods)
        // },
        // {
        //   key: removeSlash(subRoutes.nzmOA),
        //   label: <TranslatedText translationKey="Other Activity" />,
        //   onClick: () => {
        //     navigate(`${allRoutes.NZM.otherActivities}`);
        //   },
        //   disabled: true || isNavDisabled(permissions?.NZM.otherActivities)
        // },
        {
          key: removeSlash(subRoutes.nzmAM),
          label: (
            <Link to={allRoutes.NZM.asset}>
              <TranslatedText translationKey="Asset" />
            </Link>
          ),
          hidden: !checkIfHasPermissions(PermissionEnum.NZMAsset)
        },
        {
          key: removeSlash(subRoutes.nzmProduct),
          label: (
            <Link to={allRoutes.NZM.products}>
              <TranslatedText translationKey="Products" />
            </Link>
          ),
          hidden: !checkIfHasPermissions(PermissionEnum.NZMProducts)
        }
      ]
    },
    {
      key: removeSlash(Routes.ESG),
      icon: <Esg className="icon" />,
      label: <TranslatedText translationKey="ESG" />,
      route: Routes.ESG,
      hidden: !checkIfHasPermissions(PermissionEnum.ESG),
      children: [
        {
          key: removeSlash(subRoutes.peer_bechmarking),
          label: (
            <Link to={allRoutes.ESG.PEER_BENCHMARKING}>
              <TranslatedText translationKey="PEER_BENCHMARKING" />
            </Link>
          )
          // hidden: !checkIfHasPermissions(PermissionEnum.ESGPeerBechmarking)
        }
      ]
    },

    // {
    //   key: removeSlash(Routes.STRATEGY),
    //   icon: (
    //     <TrophyOutlined
    //       className="icon"
    //       style={{fontSize: '200%', color: 'black'}}
    //     />
    //   ),
    //   label: <TranslatedText translationKey="Strategy" />,
    //   route: Routes.STRATEGY,
    //   disabled: false,
    //   onClick: () => {
    //     window.open(
    //       'https://www.figma.com/proto/Oc3NFRKsFuXXM7LjogllMh/Bharat-Carbon?page-id=340%3A22241&node-id=753-4710&node-type=FRAME&viewport=3287%2C1310%2C1&t=J6t4NBfpn5fwHtUi-1&scaling=contain&content-scaling=responsive&starting-point-node-id=753%3A4710&show-proto-sidebar=1',
    //       '_blank'
    //     );
    //   }
    // },
    {
      key: removeSlash(Routes.COMMS),
      icon: <Comms className="icon" />,
      label: <TranslatedText translationKey="COMMS_MANAGER" />,
      route: Routes.COMMS,
      hidden: true
    }
  ];

  const handleRedirect = ({key}: {key: string}) => {
    if (key === removeSlash(Routes.HOME)) {
      setProduct('');
      localStorage.setItem('product', '');
    }
  };

  const onOpenChange: MenuProps['onOpenChange'] = (keys) => {
    const lastKey = keys[keys.length - 1];
    keys.shift();

    setOpenKeys(keys.length > 0 ? keys : [lastKey]);
  };

  const hideNavs = useMemo(() => {
    return [
      {
        key: removeSlash(Routes.DASHBOARD),
        icon: <Dashboard className="icon" />,
        label: <TranslatedText translationKey="DASHBOARD" />,
        route: Routes.DASHBOARD,
        // disabled: isNavDisabled(permissions?.dashboard),
        hidden: !checkIfHasPermissions(PermissionEnum.Dashboard),
        children: [
          {
            key: 'metrics',
            label: (
              <Link to={allRoutes.dashboard.metrics}>
                <TranslatedText translationKey="METRICS" />
              </Link>
            ),
            hidden: !checkIfHasPermissions(PermissionEnum.DashboardMetrics)
          },
          {
            key: 'stakeholderTracking',
            label: (
              <Link to={allRoutes.dashboard.stakeholderTracking}>
                <TranslatedText translationKey="STAKEHOLDER_TRACKING" />
              </Link>
            )
          }
        ]
      },
      {
        name: 'menu_item_configuration',
        key: removeSlash(Routes.CONFIGURATOR),
        icon: <CONFIG_SVG className="icon" />,
        label: <TranslatedText translationKey="CONFIGURATOR" />,
        route: Routes.CONFIGURATOR,
        // disabled: isNavDisabled(permissions?.dashboard),
        hidden: !checkIfHasPermissions(PermissionEnum.Configurator),
        children: [
          {
            key: removeSlash(subRoutes.Organisation_Facility),
            label: (
              <Link to={allRoutes.Configurator.org_facility}>
                <TranslatedText translationKey="ABOUT_COMPANY" />
              </Link>
            ),
            hidden: !checkIfHasPermissions(
              PermissionEnum.ConfiguratorOrganisationFacilities
            )
          },
          {
            key: removeSlash(subRoutes.Value_chain_management),
            label: (
              <Link to={allRoutes.Configurator.valueChainMng}>
                <TranslatedText translationKey="VALUE_CHAIN_MANAGEMENT" />
              </Link>
            ),
            hidden: !checkIfHasPermissions(
              PermissionEnum.ConfiguratorValueChainManagement
            )
          },
          {
            key: removeSlash(subRoutes.org_and_process_flow),
            label: (
              <Link to={allRoutes.Configurator.org_and_process_flow}>
                <TranslatedText translationKey="ORGANIZATION_HIERARCHY" />
              </Link>
            ),
            hidden: !checkIfHasPermissions(
              PermissionEnum.ConfiguratorOrganisationHierarchy
            )
          },
          {
            key: removeSlash(subRoutes.process_flow),
            label: (
              <Link to={allRoutes.Configurator.process_flow}>
                <TranslatedText translationKey="PROCESS_FLOW" />
              </Link>
            ),
            hidden: !checkIfHasPermissions(
              PermissionEnum.ConfiguratorProcessFlow
            )
              ? true
              : !processTypeFilter() // sub_category_changes
          },
          // {
          //   key: removeSlash(subRoutes.org_and_process_flow),
          //   label: <TranslatedText translationKey="Organisation Hierarchy" />,
          //   onClick: () => {
          //     navigate(`${allRoutes.Configurator.org_and_process_flow}`);
          //   }
          // },
          {
            key: removeSlash(subRoutes.data_management),
            label: (
              <Link to={allRoutes.Configurator.data_management}>
                <TranslatedText translationKey="Emission Factor Databases" />
              </Link>
            ),
            hidden: !checkIfHasPermissions(
              PermissionEnum.ConfiguratorDataManagement
            )
          },
          {
            key: removeSlash(subRoutes.userManager),
            label: (
              <Link to={allRoutes.Configurator.userManager}>
                <TranslatedText translationKey="User Management" />
              </Link>
            ),
            hidden: !checkIfHasPermissions(
              PermissionEnum.ConfiguratorUserManagement
            )
          }
          // {
          //   key: removeSlash(subRoutes.OCR),
          //   label: (
          //     <Link to={allRoutes.Configurator.OCRMain}>
          //       <TranslatedText translationKey="AI Document Manager" />
          //     </Link>
          //   )
          // }
        ]
      },
      {
        key: removeSlash(Routes.AI_DOCUMENT_MANAGER),
        icon: (
          <Link to={allRoutes.AI_DOCUMENT_MANAGER.DOCUMENT_MANAGER}>
            <AIOCR className="icon" />
          </Link>
        ),
        label: <TranslatedText translationKey="AI Document Manager" />,
        route: Routes.AI_DOCUMENT_MANAGER,
        hidden: !checkIfHasPermissions(PermissionEnum.AIDocumentManager)
      }
      // ...sideNavMapping(sideNav, product)
    ];
  }, [product]);

  return (
    <div className="topMenu">
      <span className="menuTopTitle">Main Menu</span>
      <MenuAnt
        mode="inline"
        items={
          [
            {
              key: removeSlash(Routes.HOME),
              icon: (
                <Link to={Routes.HOME}>
                  <HomeIcon className="icon" />
                </Link>
              ),
              label: <TranslatedText translationKey="Home" />,
              route: Routes.HOME,
              hidden: false
            },
            ...sideNavMapping(hideNavs, product, true)
          ] as any
        }
        onClick={handleRedirect}
        defaultSelectedKeys={
          location.pathname === '/' ? [''] : [location.pathname.split('/')[2]]
        }
        defaultOpenKeys={
          location.pathname === '/'
            ? [removeSlash(Routes.HOME)]
            : [location.pathname.split('/')[1]]
        }
        openKeys={openKeys}
        onOpenChange={onOpenChange}
        expandIcon={({isOpen}) => {
          return isOpen ? <CaretUpOutlined /> : <CaretDownOutlined />;
        }}
        selectedKeys={location.pathname.split('/')}
        className="menu"
        triggerSubMenuAction="click"
      />
    </div>
  );
};

export default Menu;
